import { SelectOption } from '../components/Select';

export default function selectOptionLabelsAsString<T>(
    options: Array<SelectOption<T>>,
): string {
    return options.map((item) => item.label).join(',');
}
